// Sélection de l'élément à masquer
const header = document.querySelector(".message-header");

// On verifie que le bandeau est bien présent sur la page

if (header) {
const closeButtons = document.querySelectorAll('.close-message-header-action');

// Fonction pour vérifier si l'en-tête doit être caché en fonction du localStorage
function checkHeaderVisibility() {
    const isHeaderHidden = localStorage.getItem('headerHidden');
    if (isHeaderHidden === 'true') {
        header.remove();

    } else {
        header.classList.remove('hidden-message-header');
    }
}

// Vérifier l'état initial de l'en-tête (au cas où la page a été rechargée)
checkHeaderVisibility();

// Ajouter un événement de clic à chaque bouton de fermeture
closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
        // Masquer complètement l'en-tête en ajoutant la classe "hidden"
        header.remove();

        // Sauvegarder dans Local Storage que l'utilisateur a fermé l'en-tête
        localStorage.setItem('headerHidden', 'true');

        // Vérifier à nouveau l'état de l'en-tête après le clic
        checkHeaderVisibility();
    });
});
}
